// Effect Managers
import { call, race, select, take } from 'redux-saga/effects'

// Controller
import gridCtrl from 'hfty-ctrl-grid'
import jobsCtrl from 'fc-ctrl-sampling-jobs'

// Selectors
import createDefaultGrid$ from '../selectors/createDefaultGrid'

// Operators
import tableOperator from 'hfty-soil-jobs-dom/src/tableOperator'


export default function *handleTableOperations (): Generator<*, *, *> {
  const { cancel } = yield race({
    submit: take([tableOperator.actionTypes.submitOperations(),
      tableOperator.actionTypes.submitOperation()]),
    cancel: take([tableOperator.actionTypes.cancelOperation(),
      tableOperator.actionTypes.cancelOperations()]),
  })

  if (cancel) {
    return
  }

  while (true) {
    const { submit, cancel, created } = yield race({
      submit: take([tableOperator.actionTypes.submitOperations(),
        tableOperator.actionTypes.submitOperation()]),
      cancel: take([tableOperator.actionTypes.cancelOperation(),
        tableOperator.actionTypes.cancelOperations()]),
      created: take(jobsCtrl.actionTypes.created()),
    })

    if (submit) {
      continue
    } else if (cancel) {
      return
    } else if (created) {
      const job = created.payload.model
      const defaultGrid = yield select(createDefaultGrid$(job))
      if (defaultGrid) {
        const jsonGridData = JSON.stringify(defaultGrid)
        yield call(gridCtrl.create, {
          model: {
            grid: jsonGridData,
            job: job.id,
          },
        })
      }
      return
    }
  }
}
